import { actionsFactory, props } from '@ngneat/effects';
import {
  IntegrationType,
  OrphanedResource,
  PagedCollectionParams,
  Vehicle,
  VehicleImport,
} from '@tmx/data-access';

const vehiclesActions = actionsFactory('vehicles');

export const loadVehicles = vehiclesActions.create(
  'Load Vehicles',
  props<{ params: PagedCollectionParams }>()
);

export const loadLinkedData = vehiclesActions.create(
  'Load Linked Data',
  props<{ vehicleIds: string[] }>()
);

export const selectVehicle = vehiclesActions.create(
  'Select Vehicle',
  props<{ vehicle: Vehicle | null }>()
);

export const removeSelectedVehicle = vehiclesActions.create(
  'Remove Selected Vehicle'
);

export const setVehiclesOffset = vehiclesActions.create(
  'Set Vehicles Offset',
  props<{ offset: number }>()
);

export const setVehiclesSort = vehiclesActions.create(
  'Set Vehicles Sort Properties',
  props<{ sortExpression: string; sortDirection: '' | 'asc' | 'desc' }>()
);

export const setVehiclesQuery = vehiclesActions.create(
  'Set Vehicles Query',
  props<{ query: string }>()
);

export const setVehiclesRowsDescriptor = vehiclesActions.create(
  'Set Vehicles Rows Descriptor To Loading Or Use Current Asset Data',
  props<{ loading: boolean }>()
);

export const removeFromVehicles = vehiclesActions.create(
  'Delete Vehicle',
  props<{ vehicleId: string }>()
);

export const clearVehicles = vehiclesActions.create('Clear Selected Vehicles');

export const loadVehicleDetails = vehiclesActions.create(
  'Load Vehicle Details',
  props<{ vehicleId: string | null }>()
);

export const amendSelectedVehicle = vehiclesActions.create(
  'Amend Selected Vehicle',
  props<{
    vehicle: Vehicle;
    skipSelection?: boolean;
  }>()
);

export const createVehicle = vehiclesActions.create(
  'Create Vehicle',
  props<{
    vehicle: Partial<Vehicle>[];
    skipSelection?: boolean;
  }>()
);

export const importVehicles = vehiclesActions.create(
  'Import List Of Vehicles',
  props<{ vehicles: VehicleImport[] }>()
);

export const clearImportResponse = vehiclesActions.create(
  'Clear Import Response'
);

export const editVehicle = vehiclesActions.create(
  'Edit Vehicle',
  props<{
    vehicle: Vehicle[];
    integrationType: IntegrationType;
    skipSelection?: boolean;
  }>()
);

export const changeVehicleGroupAssignments = vehiclesActions.create(
  'Change Vehicle Group Assignments Of A Vehicle',
  props<{
    assignmentVehicleGroupIds: number[];
    unassignmentVehicleGroupIds: number[];
    id: number;
  }>()
);

export const loadVehiclesGroups = vehiclesActions.create(
  'Load Vehicle Groups',
  props<{ vehicleId: string }>()
);

export const setCreatingNewVehicle = vehiclesActions.create(
  'Set Whether New Vehicle Is Being Created',
  props<{ creatingNewVehicle: boolean }>()
);

export const setPrefilledVehicleId = vehiclesActions.create(
  'Set Vehicle ID To Prefill In Add Edit Modal',
  props<{ id: string | null }>()
);

export const loadVehicleOrphans = vehiclesActions.create(
  'Load Vehicle Orphans'
);

export const setVehicleOrphans = vehiclesActions.create(
  'Set Vehicle Orphans',
  props<{ orphans: Map<string, OrphanedResource> }>()
);

export const setVehicleErrorMessage = vehiclesActions.create(
  'Set Vehicle Error',
  props<{ error: string | null }>()
);

export const resetCurrentStep = vehiclesActions.create(
  'Reset Current Step',
  props<{ currentStep: number }>()
);

export const saveCurrentStep = vehiclesActions.create(
  'Save Current Step',
  props<{ currentStep: number }>()
);

export const triggerTableReload = vehiclesActions.create(
  'Trigger Table Reload'
);
